<template>
  <div>
    <div
      class="actionActivator pick"
      :class="{disablePickBtn: !isPermission}"
      :disabled="!isPermission"
      slot="activator"
      v-ripple
      @click="pickChatRoom">
      受付
    </div>
  </div>
</template>

<script>
import eventBus from '@/event_bus'
import eventType from '@/components/operation/enums/eventType'

export default {
  name: 'pick_chat_room',
  props: ['chatRoomId', 'roomInfo', 'isPermission'],
  methods: {
    pickChatRoom () {
      if (!this.isPermission) return false
      eventBus.$emit(eventType.ALL_TAB_PICK_CHAT_ROOM, this.roomInfo)
    }
  }
}
</script>

<style scoped>
  .disablePickBtn {
    opacity: 0.3;
    cursor: auto!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/operation/fragments/chat_area/pick_chat_room.vue